import ctl from "@netlify/classnames-template-literals";

export const statusLabelWrapper = ctl(`
  flex
  items-center
  justify-start
  gap-1
`);

export const statusMessageWrapper = ctl(`
  flex
  bg-neutral-800
  gap-x-2
  rounded-b-2xl
  mt-4
  p-2
  items-center
  justify-center
  -mx-4
  -mb-4
`);
